import { Box, Grid } from '@mui/material';
import { Observation } from '../types/MedicalHealthInformation';
import {
  ALREADY_ANSWERED,
  MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME
} from '../constants/constants';
import { useMedicalHealthInformationContext } from '../Context';
import Card from './Card';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranchObservation = () => {
  const { setActiveStep, setDetailStep, activeMedicalHealthInformation, setFhirIdForUnmask } =
    useMedicalHealthInformationContext();
  const handleCardClick = (data: Observation) => {
    setFhirIdForUnmask(`Observation/${data.id}`);
    setDetailStep(MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME);
    setActiveStep(MEDICAL_HEALTH_INFORMATION_DETAIL_NAME);
  };

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            {activeMedicalHealthInformation.observation_list.map((data) => {
              return <Card key={data.id} onClick={() => handleCardClick(data)} label={data.name} />;
            })}
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationBranchObservation;
